/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import FlexBox from '../../components/common/FlexBox'
import { getIntervals } from '../../utils/chart'
import Dropdown from '../../components/common/Dropdown'
import Icon from '../../components/common/Icon'
import TradingViewChartRenderer from '../chart/TradingViewChartRenderer'
import DepthChartRenderer from '../chart/DepthChartRenderer'
import zIndex from '../../utils/zIndexScale'
import { withI18n } from '../../i18n/util'
import { getTokenType, TOKEN_TYPE_BEP2 } from 'utils/tokenTypes'

const TRADINGVIEW_VIEW_NAME = 'TradingView'
const CHART_INTERVALS = getIntervals()
const DEFAULT_INTERVAL_NAME = '1h'
const DEFAULT_INTERVAL = CHART_INTERVALS[DEFAULT_INTERVAL_NAME]
const CHART_INTERVALS_INV = {}
Object.keys(CHART_INTERVALS).forEach(k => {
  CHART_INTERVALS_INV[CHART_INTERVALS[k]] = k
})

const DEPTH_VIEW_NAME = 'depth'
const DEFAULT_VIEW_NAME = TRADINGVIEW_VIEW_NAME

const DEFAULT_CHART_LINE_TYPE = 'Candle'

const Wrapper = styled.div`
  padding-bottom: 10px;
  padding-top: ${({ fullScreen }) => (fullScreen ? '0' : '5px')};
  position: ${({ fullScreen }) => (fullScreen ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: ${({ fullScreen }) => (fullScreen ? zIndex.fullScreen : '0')};
  @media screen and (max-width: 768px) and (orientation: landscape) {
    position: fixed;
    top: 38px;
  }
`

const Panel = styled(FlexBox)`
  justify-content: space-between;
  background: ${({ theme }) => theme.exchangeSecondBg};
  height: 24px;
  @media (max-width: 768px) {
    justify-content: flex-end;
    position: relative;
  }
`

const LeftPanel = styled.ul`
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  list-style: none;
  margin: 0;
  padding: 0;
  @media (max-width: 768px) {
    display: none;
  }
`

const RightPanel = styled(LeftPanel)`
  margin-left: auto;
  @media (max-width: 768px) {
    display: none;
  }
`

const MobilePanel = styled.div`
  color: #f0b90b;
  height: 22px;
  line-height: 22px;
  font-weight: 500;
  font-size: 14px;
  display: none;
  padding: 0 20px;
  span {
    margin-right: 5px;
  }
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`

const IconWrap = styled.div`
  transition: transform 0.3s linear;
  transform: ${({ show }) => (show ? 'rotate(180deg)' : 'rotate(0deg)')};
`

const MobileTimeList = styled.ul`
  position: absolute;
  padding: 10px;
  background: #212833;
  width: 300px;
  top: 28px;
  right: 10px;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  flex-wrap: wrap;
  justify-content: flex-start;
  z-index: ${zIndex.dropdown};
  &:before {
    content: '';
    position: absolute;
    display: block;
    top: -8px;
    right: 10px;
    font-size: 0;
    line-height: 0;
    border-width: 10px;
    border-color: #212833;
    border-top-width: 0;
    border-style: dashed;
    border-bottom-style: solid;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  li {
    padding: 5px 10px;
    color: #fff;
  }
`

const FullScreenButton = styled.button`
  background: rgba(0, 0, 0, 0);
  border: none;
  color: ${({ theme }) => theme.exchangeIconColor};
  cursor: pointer;
  line-height: 1.15;
  &:focus {
    outline: none;
  }
`

const PanelItem = styled.li`
  align-items: center;
  cursor: pointer;
  color: ${({ theme, isSet }) => (isSet ? theme.buttonbgactive || '' : '#848E9C')};
  background-color: ${({ theme }) => theme.inputBgColor};
  border: 1px solid ${({ theme }) => theme.exchangeButtonBorderColor};
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  margin: 1px;
  padding: 0 10px;
  position: relative;
  border-radius: 3px;
  user-select: none;
  box-sizing: border-box;
  height: 18px;
  line-height: 21px;
  ${({ hasDropdown }) =>
    hasDropdown
      ? `
    min-width: 40px; /* meh prevents some moving around as content changes */
    &:after {
      content: '▾';
      right: .2em;
      position: absolute;
      transform: rotate(0);
      transition: transform .3s;
    }
  `
      : ''}
  ${({ hasDropdown, hide }) =>
    hasDropdown && !hide
      ? `
    &:after {
      transform: rotate(180deg);
    }
  `
      : ''}
`

const TimeList = styled.ul`
  display: ${({ selectedView }) => (selectedView !== DEPTH_VIEW_NAME ? 'flex;' : 'none;')};
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  left: 0;
  top: 2em;
  z-index: ${zIndex.dropdown};
  white-space: nowrap;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.35);
`

const TimeListItem = styled.li`
  color: ${({ theme, active }) => (active ? theme.chartButtonColorActive : theme.fontColor)};
  cursor: pointer;
  display: flex;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.border};
  border-left: 1px solid ${({ theme }) => theme.border};
  border-right: 1px solid ${({ theme }) => theme.border};
  button {
    background-color: ${({ theme }) => theme.boxbg};
    color: ${({ theme }) => theme.fontColor};
    border: 0;
    cursor: pointer;
    font-weight: ${({ active }) => (active ? '500' : '')};
    padding: 0.3em 1.2em;
    width: 100%;
    flex: 0 0 100%;
    outline: none;
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: ${({ theme }) => theme.chartbuttonbg};
      color: ${({ theme }) => theme.highlight};
    }
  }
  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.border};
  }
`

const ChartContent = styled.div`
  position: absolute;
  top: 25px;
  bottom: 0;
  width: 100%;
`

const replace = (name, endWith, i18nName) =>
  name.endsWith(endWith) ? name.replace(endWith, i18nName) : i18nName

const TimeDropdown = props => (
  <Dropdown component={TimeList} keys={props.keys} isOpen={!props.hide} {...props}>
    {({ key }) => (
      <TimeListItem key={key} active={key === props.intervalName}>
        <button
          onClick={() => {
            props.onClickHandler({ key: CHART_INTERVALS[key] })
          }}
          value={key}
        >
          {
            key
            // key.endsWith('m')?replace(key,'m',props.i18n.minute):replace(key,'h',props.i18n.hour)
          }
        </button>
      </TimeListItem>
    )}
  </Dropdown>
)

class ChartBox extends Component {
  static propTypes = {
    symbols: PropTypes.array,
    currentTrade: PropTypes.string,
    tradingViewId: PropTypes.string,
    tickerSize: PropTypes.string,
    formatI18nText: PropTypes.func.isRequired,
  }

  static defaultProps = {
    symbols: [],
    currentTrade: '',
    tickerSize: '',
    tradingViewId: 'tradingview_4bca8',
  }

  constructor(props) {
    super(props)
    this.state = {
      fullScreen: false,
      mMenuPopped: false,
      hMenuPopped: false,
      IndicatorShowTV: false,
      moblieTimePopped: false,
      intervalName: '1h',
      interval: DEFAULT_INTERVAL,
      selectedView: DEFAULT_VIEW_NAME,
      lineType: DEFAULT_CHART_LINE_TYPE,
      scale: 500,
      size: {},
      tokenType: getTokenType(),
    }
  }

  _chartContainerRef = React.createRef()

  shouldComponentUpdate(nextProps, nextState) {
    const { symbols, currentTrade } = this.props
    const {
      intervalName,
      fullScreen,
      mMenuPopped,
      selectedView,
      IndicatorShowTV,
      moblieTimePopped,
      hMenuPopped,
    } = this.state
    if (
      intervalName !== nextState.intervalName ||
      fullScreen !== nextState.fullScreen ||
      hMenuPopped !== nextState.hMenuPopped ||
      mMenuPopped !== nextState.mMenuPopped ||
      selectedView !== nextState.selectedView ||
      IndicatorShowTV !== nextState.IndicatorShowTV ||
      currentTrade !== nextProps.currentTrade ||
      moblieTimePopped !== nextState.moblieTimePopped
    ) {
      return true
    }
    let shouldUpdate = false
    if (symbols.length !== nextProps.symbols.length) {
      shouldUpdate = true
    } else {
      for (let i = 0, len = symbols.length; i < len; i++) {
        if (symbols[i].name !== nextProps.symbols[i].name) {
          shouldUpdate = true
          break
        }
      }
    }

    return shouldUpdate
  }

  componentDidMount() {
    window.document.addEventListener('keydown', this._keyDown)
    const intervalName = window.localStorage.getItem('bn.intervalName')
    const interval = CHART_INTERVALS[intervalName]
    if (intervalName && interval) {
      this.setState({ intervalName: '1h', interval: '3600' })
    }
    this._getSize()
  }

  componentDidUpdate() {
    this._getSize()
    const { tokenType } = this.state
    const currentTokenType = getTokenType()
    if (currentTokenType !== tokenType) {
      this.setState({ intervalName: '1h', interval: '3600' })
    }
  }

  componentWillUnmount() {
    window.document.removeEventListener('keydown', this._keyDown)
  }

  _getSize = () => {
    const { width, height } = this._chartContainerRef?.current?.getBoundingClientRect()
    this.setState({ size: { width, height } })
  }

  _keyDown = ev => {
    const { fullScreen } = this.state
    if (fullScreen && ev.keyCode === 27) {
      this.setState({ fullScreen: false })
    }
  }

  _setInterval = (ev, that) => {
    if (!ev || !ev.key) return
    const self = that || this
    const type = ev.type || 'Candle'
    const value = ev.key
    const interval = parseInt(value, 10)
    const intervalName = CHART_INTERVALS_INV[value]
    self.setState({ interval, intervalName, lineType: type }, () => {
      if (!window.localStorage) return
      window.localStorage.setItem('bn.lineType', type)
      window.localStorage.setItem('bn.interval', interval)
      window.localStorage.setItem('bn.intervalName', intervalName)
    })
  }

  _toggleMinuteMenu() {
    this.setState({
      hMenuPopped: false,
      mMenuPopped: !this.state.mMenuPopped,
    })
  }

  _toggleHourMenu() {
    this.setState({
      hMenuPopped: !this.state.hMenuPopped,
      mMenuPopped: false,
    })
  }

  _toggleFullScreen = event => {
    event.preventDefault()
    this.setState(({ fullScreen }) => ({ fullScreen: !fullScreen }))
  }

  _changeView = (event, newView) => {
    event.preventDefault()
    this.setState(
      {
        selectedView: newView,
      },
      () => {
        window.localStorage.setItem('bn.selectedView', newView)
      }
    )
  }

  _showTimeList = () => {
    const { moblieTimePopped } = this.state
    this.setState({ moblieTimePopped: !moblieTimePopped })
  }

  _selectMobileTime = interval => {
    this._setInterval({ key: CHART_INTERVALS[interval] })
    this.setState({ moblieTimePopped: false })
  }

  render() {
    const {
      fullScreen,
      mMenuPopped,
      hMenuPopped,
      intervalName,
      selectedView,
      interval,
      lineType,
      moblieTimePopped,
      size,
      scale,
    } = this.state
    const { symbols, tickerSize, currentTrade, tradingViewId, formatI18nText } = this.props
    return (
      <Wrapper fullScreen={fullScreen}>
        <Panel>
          <LeftPanel hidden={selectedView === DEPTH_VIEW_NAME}>
            {getTokenType() === TOKEN_TYPE_BEP2 && (
              <>
                <PanelItem
                  role="menuitem"
                  onClick={() => {
                    this._setInterval({ key: CHART_INTERVALS['1m'], type: 'Line' })
                  }}
                  onKeyDown={() => {
                    this._setInterval({ key: CHART_INTERVALS['1m'], type: 'Line' })
                  }}
                  isSet={intervalName === '1m' && lineType === 'Line'}
                >
                  {'Time'}
                </PanelItem>
                <PanelItem
                  role="menu"
                  aria-expanded={mMenuPopped}
                  onClick={() => this._toggleMinuteMenu()}
                  onKeyDown={() => this._toggleMinuteMenu()}
                  hasDropdown="true"
                  hide={!mMenuPopped}
                  isSet={intervalName.endsWith('m') && lineType !== 'Line'}
                >
                  {replace(intervalName, 'm', 'Min')}
                  <TimeDropdown
                    hide={!mMenuPopped}
                    i18n={{}}
                    keys={Object.keys(CHART_INTERVALS).filter(_interval => _interval.endsWith('m'))}
                    onClickHandler={ev => {
                      this._setInterval(ev, this)
                    }}
                    intervalName={intervalName}
                  />
                </PanelItem>
              </>
            )}
            <PanelItem
              role="menu"
              aria-expanded={hMenuPopped}
              onClick={() => this._toggleHourMenu()}
              onKeyDown={() => this._toggleHourMenu()}
              hasDropdown="true"
              hide={!hMenuPopped}
              isSet={intervalName.endsWith('h')}
            >
              {replace(intervalName, 'h', 'Hour')}
              <TimeDropdown
                hide={!hMenuPopped}
                i18n={{}}
                keys={Object.keys(CHART_INTERVALS).filter(_interval => _interval.endsWith('h'))}
                onClickHandler={this._setInterval}
                intervalName={intervalName}
              />
            </PanelItem>
            <PanelItem
              role="menuitem"
              onClick={() => {
                this._setInterval({ key: CHART_INTERVALS['1d'] })
              }}
              onKeyDown={() => {
                this._setInterval({ key: CHART_INTERVALS['1d'] })
              }}
              isSet={intervalName === '1d'}
            >
              {'1D'}
            </PanelItem>
            <PanelItem
              role="menuitem"
              onClick={() => {
                this._setInterval({ key: CHART_INTERVALS['1w'] })
              }}
              onKeyDown={() => {
                this._setInterval({ key: CHART_INTERVALS['1w'] })
              }}
              isSet={intervalName === '1w'}
            >
              {'1W'}
            </PanelItem>
            <PanelItem
              role="menuitem"
              onClick={() => {
                this._setInterval({ key: CHART_INTERVALS['1M'] })
              }}
              onKeyDown={() => {
                this._setInterval({ key: CHART_INTERVALS['1M'] })
              }}
              isSet={intervalName === '1M'}
            >
              {'1M'}
            </PanelItem>
            <PanelItem
              role="menuitem"
              hidden={false}
              onClick={() => {
                this.setState({ IndicatorShowTV: !this.state.IndicatorShowTV })
              }}
              onKeyDown={() => {
                this.setState({ IndicatorShowTV: !this.state.IndicatorShowTV })
              }}
              isSet={false}
              className="technical-item"
            >
              {'Technical Ind'}
            </PanelItem>
          </LeftPanel>
          <RightPanel>
            {
              <PanelItem
                role="menuitem"
                onClick={ev => {
                  this._changeView(ev, DEFAULT_VIEW_NAME)
                }}
                onKeyDown={ev => {
                  this._changeView(ev, DEFAULT_VIEW_NAME)
                }}
                isSet={selectedView === DEFAULT_VIEW_NAME}
              >
                TradingView
              </PanelItem>
            }
            {
              <PanelItem
                role="menuitem"
                onClick={ev => {
                  this._changeView(ev, DEPTH_VIEW_NAME)
                }}
                onKeyDown={ev => {
                  this._changeView(ev, DEPTH_VIEW_NAME)
                }}
                isSet={selectedView === DEPTH_VIEW_NAME}
              >
                {formatI18nText('exchange.chartbox.depth')}
              </PanelItem>
            }
            <PanelItem>
              <FullScreenButton onClick={this._toggleFullScreen} aria-label="full screen">
                <Icon type={fullScreen ? 'offfull' : 'full'} />
              </FullScreenButton>
            </PanelItem>
          </RightPanel>
          <MobilePanel onClick={this._showTimeList}>
            <span>{intervalName}</span>
            <IconWrap show={moblieTimePopped}>
              <Icon type="sanjiaojiantouxia-B" color="#f0b90b" size="12" />
            </IconWrap>
            <MobileTimeList show={moblieTimePopped}>
              {Object.keys(CHART_INTERVALS).map(interval => (
                <li
                  key={interval}
                  onClick={() => {
                    this._selectMobileTime(interval)
                  }}
                >
                  {interval}
                </li>
              ))}
            </MobileTimeList>
          </MobilePanel>
        </Panel>
        <ChartContent fullScreen={fullScreen} ref={this._chartContainerRef}>
          {currentTrade && (
            <TradingViewChartRenderer
              hidden={selectedView !== TRADINGVIEW_VIEW_NAME}
              fullScreen={fullScreen}
              selectedView={selectedView}
              showIndicatorsDialog={this.state.IndicatorShowTV}
              symbol={currentTrade}
              interval={interval}
              lineType={lineType}
              symbols={symbols}
              tradingViewId={tradingViewId}
            />
          )}
          {currentTrade && (
            <DepthChartRenderer
              hidden={selectedView !== DEFAULT_VIEW_NAME}
              fullScreen={fullScreen}
              selectedView={selectedView}
              interval={interval}
            />
          )
          /* currentTrade &&
          <DeptchChart
            size={size}
            scale={scale}
            tickerSize={tickerSize}
            hidden={selectedView !== DEPTH_VIEW_NAME}
          /> */
          }
        </ChartContent>
      </Wrapper>
    )
  }
}

const mapStateToProps = ({
  exchange: { currentTrade },
  tradePairs: { pairs },
  tickers: { tickerSize: ts },
}) => {
  const symbols = pairs.map(pair => ({
    symbol: `${pair.base_asset_symbol}_${pair.quote_asset_symbol}`,
    tickSize: pair.tick_size,
  }))
  const tickerSize = ts[currentTrade] || '0.00000001'
  return { symbols, currentTrade, tickerSize }
}

export default withI18n(connect(mapStateToProps)(ChartBox))
